import React, { Component } from 'react';
import './App.scss';

import { PortfolioPage } from './portfolio/PortfolioPage';

class App extends Component {
  render() {
    return (
      <div>
          <PortfolioPage/>
      </div>
    );
  }
}

export default App;
